// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__zbwkI","logo_title":"Logo_logo_title__mLYl9","logo_subtitle":"Logo_logo_subtitle__+0aX3","logo_span":"Logo_logo_span__fAXo7"};